import { Divider, Form, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import GlobalService from '../../../../services/Global.service';

const StepPreview = (props) => {
    const { t } = useTranslation();
    const { setPreviewMode, setCurrentSelectList } = props; 
    const [previewLang, setPreviewLang] = useState('TH');
    const [logo, setLogo] = useState('');

    const previewData = props?.data;
    useEffect(() => {
        const getImage = async () => {
            try {
                const { data } = await GlobalService.getImageNoSecure(
                    previewData?.freeFormPolicy.freeFormCompanyLogoId
                );
                if (data.resultData?.imageId) {
                    setLogo(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                } else {
                    setLogo('');
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (previewData?.freeFormPolicy.freeFormCompanyLogoId) {
            getImage();
        } else {
            setLogo('');
        }
    }, [previewData]);

    return (
        <Form name="preview">
            <div className="px-4">
                <Divider className="mb-1" />
                <div className={`py-4 flex space-x-2 text-tiny`}>
                    <span
                        style={{ borderRight: '1px solid #DBDBDB' }}
                        onClick={() => {
                            setPreviewLang('TH');
                        }}
                        className={`${previewLang === 'TH'
                                ? 'text-[#1890FF] font-semibold'
                                : ''
                            } cursor-pointer hover:opacity-80 pr-2`}
                    >
                        {t('policy.th')}
                    </span>
                    <span
                        onClick={() => {
                            setPreviewLang('EN');
                        }}
                        className={`${previewLang === 'EN'
                                ? 'text-[#1890FF] font-semibold'
                                : ''
                            } cursor-pointer hover:opacity-80`}
                    >
                        {t('policy.en')}
                    </span>
                </div>
                <div className=" space-y-4">
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Policy Name and Data Subject Type'
                                    : 'ชื่อนโยบายและประเภทเจ้าของข้อมูล'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    setPreviewMode(false); // Switch back to edit mode
                                    setCurrentSelectList(0); // Go to the first section (sequence 0)
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Policy Name'
                                    : 'ชื่อนโยบาย'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewLang === 'TH'
                                    ? previewData?.freeFormPolicy.freeFormPolicyNameTh ||
                                    '-'
                                    : previewData?.freeFormPolicy.freeFormPolicyNameEn ||
                                    '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Organization name (or Owner Name)'
                                    : 'ชื่อองค์กร (หรือชื่อบุคคลเจ้าของ)'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewLang === 'TH'
                                    ? previewData?.freeFormPolicy.freeFormCompanyNameTh ||
                                    '-'
                                    : previewData?.freeFormPolicy.freeFormCompanyNameEn ||
                                    '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'What types of data subjects does this policy apply to'
                                    : 'นโยบายนี้ใช้กับเจ้าของข้อมูลประเภทใด'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewData?.freeFormPolicy.freeFormPolicyDataSubjectType
                                    ?.map((ds) =>
                                        previewLang === 'TH'
                                            ? ds.freeFormDataSubjectNameTh
                                            : ds.freeFormDataSubjectNameEn
                                    )
                                    .join(', ')}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Introduction'
                                    : 'บnนำ'}
                            </div>
                            <div className="py-2 text-[#65707A]"> 
                            {previewLang === 'EN'
                                    ? previewData?.freeFormPolicy.freeFormIntroductionEn ? 
                                    <div dangerouslySetInnerHTML={{ __html: previewData?.freeFormPolicy.freeFormIntroductionEn }} /> : "-"
                                    : previewData?.freeFormPolicy.freeFormIntroductionTh ? 
                                    <div dangerouslySetInnerHTML={{ __html: previewData?.freeFormPolicy.freeFormIntroductionTh }} /> : "-"}
                               
                            </div>
                          
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'TH' ? 'โลโก้องค์กร' : 'Logo'}
                            </div>
                            <div className="text-[#65707A]">
                            {logo ? (
                                // eslint-disable-next-line jsx-a11y/img-redundant-alt
                                <img
                                    className="w-auto h-16 rounded-lg object-cover"
                                    style={{
                                        border: '1px solid #DBDBDB',
                                    }}
                                    src={logo}
                                    alt="image"
                                />
                            ) : (
                                svgNoImage
                            )}
                        </div>
                        </div>
                    </div>
                    {previewData?.freeFormDataList?.sort((a, b) => a.sequence - b.sequence).map((item) =>
                        <div>
                            <div
                                className="flex px-4 py-1 items-center mb-4"
                                style={{ background: '#F4F6FC' }}
                            >
                                <div className="flex-1 text-purple-PHX font-semibold">
                                    {previewLang === 'EN'
                                        ? item.freeFormTitleEn
                                        : item.freeFormTitleTh}
                                </div>
                                <div
                                    className="mt-1 hover:opacity-80 cursor-pointer"
                                    onClick={() => {
                                        setPreviewMode(false); // Switch back to edit mode
                                        setCurrentSelectList(item.sequence); // Go to the first section (sequence 0)
                                    }}
                                >
                                    {EditIcon}
                                </div>
                            </div>
                            <div className="text-sm space-y-2">
                                <div dangerouslySetInnerHTML={{ __html: previewLang === 'EN'
                                        ? item.freeFormContentEn
                                        : item.freeFormContentTh }} />
                            </div>
                        </div>
                    )
                    }

                </div>

            </div>
        </Form>
    );
};

export default StepPreview;

const EditIcon = (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
            fill="#7B67FB"
        />
        <path
            d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
            fill="#7B67FB"
        />
    </svg>
);

const Dot = (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" />
    </svg>
);

export const svgNoImage = (
    <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx={20} cy={20} r={20} fill="#EDEEF9" />
        <g opacity="0.5">
            <path
                d="M27 11H13C11.8954 11 11 11.8954 11 13V27C11 28.1046 11.8954 29 13 29H27C28.1046 29 29 28.1046 29 27V13C29 11.8954 28.1046 11 27 11Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29 23L24 18L13 29"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
